exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.billboard {\n  width: 100%;\n  max-width: 1140px;\n  margin: 40px auto 0;\n  padding: 0 15px; }\n  @media screen and (max-width: 768px) {\n    .billboard {\n      margin: 40px auto 0;\n      padding: 0 10px; } }\n\n.billboard-list {\n  text-align: center;\n  margin-bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/banner-billboard/banner-billboard.component.scss
// module id = 875
// module chunks = 22